// src/pages/admin/MasterData.tsx - IMPROVED WITH MODERN TABS
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Plus, Edit, Trash2, Search, Tag, BookOpen, Target, Calendar,
  Check, X, Users, Microscope, Heart, Shield,
  LayoutGrid, List, RefreshCw, Sparkles,
  // Tambahan icon baru
  GraduationCap, Laptop, Cpu, Database, Server, Library,
  FlaskConical, TestTube, Scale, FileText, Handshake, Globe,
  Building2, HardHat, Wrench, UserCheck, Award, Briefcase,
  Megaphone, Camera, Radio, Wallet, Calculator, ClipboardList,
  Network, BookMarked, ScrollText, Landmark, PenTool, Lightbulb,
  Rocket, Presentation, CircuitBoard, Beaker,
  Construction, Package, ShieldCheck, BadgeCheck, Medal,
  PartyPopper, Newspaper, Share2, TrendingUp, DollarSign,
  CreditCard, PiggyBank, FileSpreadsheet, UsersRound, UserCog,
  Building, Home, Warehouse, Lock, AlertTriangle,
  Plane, Flag, Languages, Mail, Phone,
  Activity, Zap, Settings,
  Folder, Archive, Send, MessageSquare, Bell,
  Clock, MapPin,
  Wifi, Cloud, HardDrive, Monitor,
  Video, Image,
  FileCheck, Files,
  Info, HelpCircle,
  Star, Crown, Gem
} from 'lucide-react';
import { Button, Card, Breadcrumb, Modal, Input, Select, Textarea, Loading, LogoLoadingMark, LoadingLabel } from '../../components/ui';
import toast from 'react-hot-toast';
import { adminService } from '../../services/admin';
import { getErrorMessage } from '../../utils/errorHandler';
import { KategoriMasalah, StandarSPMI, IndikatorSPMI, Periode } from '../../types';

type TabId = 'kategori' | 'standar' | 'indikator' | 'periode';

interface TabConfig {
  id: TabId;
  label: string;
  shortLabel: string;
  icon: React.ReactNode;
  color: string;
  bgColor: string;
  description: string;
}

const TAB_CONFIG: TabConfig[] = [
  {
    id: 'kategori',
    label: 'Kategori Masalah',
    shortLabel: 'Kategori',
    icon: <Tag className="w-5 h-5" />,
    color: 'text-orange-600',
    bgColor: 'bg-orange-500',
    description: 'Klasifikasi jenis masalah',
  },
  {
    id: 'standar',
    label: 'Standar SPMI',
    shortLabel: 'Standar',
    icon: <BookOpen className="w-5 h-5" />,
    color: 'text-blue-600',
    bgColor: 'bg-blue-500',
    description: 'Standar penjaminan mutu',
  },
  {
    id: 'indikator',
    label: 'Indikator SPMI',
    shortLabel: 'Indikator',
    icon: <Target className="w-5 h-5" />,
    color: 'text-purple-600',
    bgColor: 'bg-purple-500',
    description: 'Indikator dan target mutu',
  },
  {
    id: 'periode',
    label: 'Periode',
    shortLabel: 'Periode',
    icon: <Calendar className="w-5 h-5" />,
    color: 'text-teal-600',
    bgColor: 'bg-teal-500',
    description: 'Periode akademik',
  },
];

// ===== ICON OPTIONS YANG DIPERLUAS =====
interface IconOption {
  value: string;
  label: string;
  category: string;
  icon: React.ReactNode;
}

const ICON_OPTIONS: IconOption[] = [
  // AKADEMIK & PEMBELAJARAN
  { value: 'GraduationCap', label: 'Akademik', category: 'Akademik', icon: <GraduationCap className="w-4 h-4" /> },
  { value: 'BookOpen', label: 'Pembelajaran', category: 'Akademik', icon: <BookOpen className="w-4 h-4" /> },
  { value: 'Presentation', label: 'Perkuliahan', category: 'Akademik', icon: <Presentation className="w-4 h-4" /> },
  { value: 'PenTool', label: 'Kurikulum', category: 'Akademik', icon: <PenTool className="w-4 h-4" /> },
  { value: 'Lightbulb', label: 'Inovasi', category: 'Akademik', icon: <Lightbulb className="w-4 h-4" /> },
  { value: 'Rocket', label: 'Pengembangan', category: 'Akademik', icon: <Rocket className="w-4 h-4" /> },

  // TEKNOLOGI & SISTEM INFORMASI
  { value: 'Laptop', label: 'Teknologi', category: 'Teknologi', icon: <Laptop className="w-4 h-4" /> },
  { value: 'Cpu', label: 'Sistem', category: 'Teknologi', icon: <Cpu className="w-4 h-4" /> },
  { value: 'Database', label: 'Database', category: 'Teknologi', icon: <Database className="w-4 h-4" /> },
  { value: 'Server', label: 'Server', category: 'Teknologi', icon: <Server className="w-4 h-4" /> },
  { value: 'Network', label: 'Jaringan', category: 'Teknologi', icon: <Network className="w-4 h-4" /> },
  { value: 'Cloud', label: 'Cloud', category: 'Teknologi', icon: <Cloud className="w-4 h-4" /> },
  { value: 'Monitor', label: 'Monitor', category: 'Teknologi', icon: <Monitor className="w-4 h-4" /> },
  { value: 'Wifi', label: 'WiFi', category: 'Teknologi', icon: <Wifi className="w-4 h-4" /> },
  { value: 'CircuitBoard', label: 'Hardware', category: 'Teknologi', icon: <CircuitBoard className="w-4 h-4" /> },
  { value: 'HardDrive', label: 'Storage', category: 'Teknologi', icon: <HardDrive className="w-4 h-4" /> },

  // PERPUSTAKAAN
  { value: 'Library', label: 'Perpustakaan', category: 'Perpustakaan', icon: <Library className="w-4 h-4" /> },
  { value: 'BookMarked', label: 'Koleksi Buku', category: 'Perpustakaan', icon: <BookMarked className="w-4 h-4" /> },
  { value: 'ScrollText', label: 'Dokumen', category: 'Perpustakaan', icon: <ScrollText className="w-4 h-4" /> },
  { value: 'Archive', label: 'Arsip', category: 'Perpustakaan', icon: <Archive className="w-4 h-4" /> },
  { value: 'Files', label: 'Berkas', category: 'Perpustakaan', icon: <Files className="w-4 h-4" /> },

  // LABORATORIUM
  { value: 'FlaskConical', label: 'Laboratorium', category: 'Lab', icon: <FlaskConical className="w-4 h-4" /> },
  { value: 'TestTube', label: 'Penelitian', category: 'Lab', icon: <TestTube className="w-4 h-4" /> },
  { value: 'Microscope', label: 'Riset', category: 'Lab', icon: <Microscope className="w-4 h-4" /> },
  { value: 'Beaker', label: 'Eksperimen', category: 'Lab', icon: <Beaker className="w-4 h-4" /> },

  // SDM & KEUANGAN
  { value: 'Users', label: 'SDM', category: 'SDM', icon: <Users className="w-4 h-4" /> },
  { value: 'UsersRound', label: 'Tim', category: 'SDM', icon: <UsersRound className="w-4 h-4" /> },
  { value: 'UserCog', label: 'Manajemen SDM', category: 'SDM', icon: <UserCog className="w-4 h-4" /> },
  { value: 'Wallet', label: 'Keuangan', category: 'Keuangan', icon: <Wallet className="w-4 h-4" /> },
  { value: 'Calculator', label: 'Anggaran', category: 'Keuangan', icon: <Calculator className="w-4 h-4" /> },
  { value: 'DollarSign', label: 'Penggajian', category: 'Keuangan', icon: <DollarSign className="w-4 h-4" /> },
  { value: 'CreditCard', label: 'Pembayaran', category: 'Keuangan', icon: <CreditCard className="w-4 h-4" /> },
  { value: 'PiggyBank', label: 'Tabungan', category: 'Keuangan', icon: <PiggyBank className="w-4 h-4" /> },
  { value: 'FileSpreadsheet', label: 'Laporan Keuangan', category: 'Keuangan', icon: <FileSpreadsheet className="w-4 h-4" /> },
  { value: 'ClipboardList', label: 'Perencanaan', category: 'Keuangan', icon: <ClipboardList className="w-4 h-4" /> },

  // HUKUM & TATA KELOLA
  { value: 'Scale', label: 'Hukum', category: 'Hukum', icon: <Scale className="w-4 h-4" /> },
  { value: 'FileText', label: 'Peraturan', category: 'Hukum', icon: <FileText className="w-4 h-4" /> },
  { value: 'Landmark', label: 'Kelembagaan', category: 'Hukum', icon: <Landmark className="w-4 h-4" /> },
  { value: 'Shield', label: 'Kepatuhan', category: 'Hukum', icon: <Shield className="w-4 h-4" /> },
  { value: 'FileCheck', label: 'Legalitas', category: 'Hukum', icon: <FileCheck className="w-4 h-4" /> },

  // KERJASAMA
  { value: 'Handshake', label: 'Kerjasama', category: 'Kerjasama', icon: <Handshake className="w-4 h-4" /> },
  { value: 'Globe', label: 'Internasional', category: 'Kerjasama', icon: <Globe className="w-4 h-4" /> },
  { value: 'Plane', label: 'Luar Negeri', category: 'Kerjasama', icon: <Plane className="w-4 h-4" /> },
  { value: 'Flag', label: 'Mitra', category: 'Kerjasama', icon: <Flag className="w-4 h-4" /> },
  { value: 'Languages', label: 'Bahasa', category: 'Kerjasama', icon: <Languages className="w-4 h-4" /> },

  // SARANA PRASARANA
  { value: 'Building2', label: 'Gedung', category: 'Sarpras', icon: <Building2 className="w-4 h-4" /> },
  { value: 'Building', label: 'Fasilitas', category: 'Sarpras', icon: <Building className="w-4 h-4" /> },
  { value: 'Home', label: 'Ruangan', category: 'Sarpras', icon: <Home className="w-4 h-4" /> },
  { value: 'Warehouse', label: 'Gudang', category: 'Sarpras', icon: <Warehouse className="w-4 h-4" /> },
  { value: 'Construction', label: 'Konstruksi', category: 'Sarpras', icon: <Construction className="w-4 h-4" /> },
  { value: 'HardHat', label: 'K3', category: 'Sarpras', icon: <HardHat className="w-4 h-4" /> },
  { value: 'Wrench', label: 'Pemeliharaan', category: 'Sarpras', icon: <Wrench className="w-4 h-4" /> },
  { value: 'Package', label: 'Aset', category: 'Sarpras', icon: <Package className="w-4 h-4" /> },
  { value: 'ShieldCheck', label: 'Keamanan', category: 'Sarpras', icon: <ShieldCheck className="w-4 h-4" /> },
  { value: 'Lock', label: 'Keamanan', category: 'Sarpras', icon: <Lock className="w-4 h-4" /> },
  { value: 'AlertTriangle', label: 'Bahaya', category: 'Sarpras', icon: <AlertTriangle className="w-4 h-4" /> },

  // KEMAHASISWAAN
  { value: 'Heart', label: 'Kemahasiswaan', category: 'Mahasiswa', icon: <Heart className="w-4 h-4" /> },
  { value: 'UserCheck', label: 'Mahasiswa', category: 'Mahasiswa', icon: <UserCheck className="w-4 h-4" /> },
  { value: 'Award', label: 'Prestasi', category: 'Mahasiswa', icon: <Award className="w-4 h-4" /> },
  { value: 'Medal', label: 'Beasiswa', category: 'Mahasiswa', icon: <Medal className="w-4 h-4" /> },
  { value: 'PartyPopper', label: 'Kegiatan', category: 'Mahasiswa', icon: <PartyPopper className="w-4 h-4" /> },
  { value: 'BadgeCheck', label: 'Organisasi', category: 'Mahasiswa', icon: <BadgeCheck className="w-4 h-4" /> },
  { value: 'Star', label: 'UKM', category: 'Mahasiswa', icon: <Star className="w-4 h-4" /> },

  // ALUMNI & KARIR
  { value: 'Briefcase', label: 'Karir', category: 'Alumni', icon: <Briefcase className="w-4 h-4" /> },
  { value: 'TrendingUp', label: 'Tracer Study', category: 'Alumni', icon: <TrendingUp className="w-4 h-4" /> },
  { value: 'Crown', label: 'Alumni', category: 'Alumni', icon: <Crown className="w-4 h-4" /> },
  { value: 'Gem', label: 'Ikatan Alumni', category: 'Alumni', icon: <Gem className="w-4 h-4" /> },

  // HUMAS & MARKETING
  { value: 'Megaphone', label: 'Humas', category: 'Humas', icon: <Megaphone className="w-4 h-4" /> },
  { value: 'Camera', label: 'Dokumentasi', category: 'Humas', icon: <Camera className="w-4 h-4" /> },
  { value: 'Radio', label: 'Media', category: 'Humas', icon: <Radio className="w-4 h-4" /> },
  { value: 'Newspaper', label: 'Publikasi', category: 'Humas', icon: <Newspaper className="w-4 h-4" /> },
  { value: 'Share2', label: 'Sosial Media', category: 'Humas', icon: <Share2 className="w-4 h-4" /> },
  { value: 'Video', label: 'Video', category: 'Humas', icon: <Video className="w-4 h-4" /> },
  { value: 'Image', label: 'Branding', category: 'Humas', icon: <Image className="w-4 h-4" /> },

  // KOMUNIKASI
  { value: 'Mail', label: 'Email', category: 'Komunikasi', icon: <Mail className="w-4 h-4" /> },
  { value: 'Phone', label: 'Telepon', category: 'Komunikasi', icon: <Phone className="w-4 h-4" /> },
  { value: 'MessageSquare', label: 'Pesan', category: 'Komunikasi', icon: <MessageSquare className="w-4 h-4" /> },
  { value: 'Bell', label: 'Notifikasi', category: 'Komunikasi', icon: <Bell className="w-4 h-4" /> },
  { value: 'Send', label: 'Kirim', category: 'Komunikasi', icon: <Send className="w-4 h-4" /> },

  // UMUM & LAINNYA
  { value: 'Tag', label: 'Umum', category: 'Umum', icon: <Tag className="w-4 h-4" /> },
  { value: 'Settings', label: 'Pengaturan', category: 'Umum', icon: <Settings className="w-4 h-4" /> },
  { value: 'Folder', label: 'Folder', category: 'Umum', icon: <Folder className="w-4 h-4" /> },
  { value: 'Clock', label: 'Waktu', category: 'Umum', icon: <Clock className="w-4 h-4" /> },
  { value: 'MapPin', label: 'Lokasi', category: 'Umum', icon: <MapPin className="w-4 h-4" /> },
  { value: 'Info', label: 'Informasi', category: 'Umum', icon: <Info className="w-4 h-4" /> },
  { value: 'HelpCircle', label: 'Bantuan', category: 'Umum', icon: <HelpCircle className="w-4 h-4" /> },
  { value: 'Zap', label: 'Cepat', category: 'Umum', icon: <Zap className="w-4 h-4" /> },
  { value: 'Activity', label: 'Aktivitas', category: 'Umum', icon: <Activity className="w-4 h-4" /> },
  { value: 'Target', label: 'Target', category: 'Umum', icon: <Target className="w-4 h-4" /> },
];

// Group icons by category for better organization
const ICON_CATEGORIES = [
  { id: 'Akademik', label: '📚 Akademik & Pembelajaran' },
  { id: 'Teknologi', label: '💻 Teknologi & SI' },
  { id: 'Perpustakaan', label: '📖 Perpustakaan' },
  { id: 'Lab', label: '🔬 Laboratorium' },
  { id: 'SDM', label: '👥 SDM' },
  { id: 'Keuangan', label: '💰 Keuangan' },
  { id: 'Hukum', label: '⚖️ Hukum & Tata Kelola' },
  { id: 'Kerjasama', label: '🤝 Kerjasama' },
  { id: 'Sarpras', label: '🏢 Sarana Prasarana' },
  { id: 'Mahasiswa', label: '🎓 Kemahasiswaan' },
  { id: 'Alumni', label: '🎯 Alumni & Karir' },
  { id: 'Humas', label: '📢 Humas & Marketing' },
  { id: 'Komunikasi', label: '📱 Komunikasi' },
  { id: 'Umum', label: '📌 Umum' },
];

const getIconComponent = (iconName?: string | null, size: string = 'w-6 h-6'): React.ReactNode => {
  const iconMap: Record<string, React.ReactNode> = {
    // Akademik
    'GraduationCap': <GraduationCap className={size} />,
    'BookOpen': <BookOpen className={size} />,
    'Presentation': <Presentation className={size} />,
    'PenTool': <PenTool className={size} />,
    'Lightbulb': <Lightbulb className={size} />,
    'Rocket': <Rocket className={size} />,

    // Teknologi
    'Laptop': <Laptop className={size} />,
    'Cpu': <Cpu className={size} />,
    'Database': <Database className={size} />,
    'Server': <Server className={size} />,
    'Network': <Network className={size} />,
    'Cloud': <Cloud className={size} />,
    'Monitor': <Monitor className={size} />,
    'Wifi': <Wifi className={size} />,
    'CircuitBoard': <CircuitBoard className={size} />,
    'HardDrive': <HardDrive className={size} />,

    // Perpustakaan
    'Library': <Library className={size} />,
    'BookMarked': <BookMarked className={size} />,
    'ScrollText': <ScrollText className={size} />,
    'Archive': <Archive className={size} />,
    'Files': <Files className={size} />,

    // Lab
    'FlaskConical': <FlaskConical className={size} />,
    'TestTube': <TestTube className={size} />,
    'Microscope': <Microscope className={size} />,
    'Beaker': <Beaker className={size} />,

    // SDM & Keuangan
    'Users': <Users className={size} />,
    'UsersRound': <UsersRound className={size} />,
    'UserCog': <UserCog className={size} />,
    'Wallet': <Wallet className={size} />,
    'Calculator': <Calculator className={size} />,
    'DollarSign': <DollarSign className={size} />,
    'CreditCard': <CreditCard className={size} />,
    'PiggyBank': <PiggyBank className={size} />,
    'FileSpreadsheet': <FileSpreadsheet className={size} />,
    'ClipboardList': <ClipboardList className={size} />,

    // Hukum
    'Scale': <Scale className={size} />,
    'FileText': <FileText className={size} />,
    'Landmark': <Landmark className={size} />,
    'Shield': <Shield className={size} />,
    'FileCheck': <FileCheck className={size} />,

    // Kerjasama
    'Handshake': <Handshake className={size} />,
    'Globe': <Globe className={size} />,
    'Plane': <Plane className={size} />,
    'Flag': <Flag className={size} />,
    'Languages': <Languages className={size} />,

    // Sarpras
    'Building2': <Building2 className={size} />,
    'Building': <Building className={size} />,
    'Home': <Home className={size} />,
    'Warehouse': <Warehouse className={size} />,
    'Construction': <Construction className={size} />,
    'HardHat': <HardHat className={size} />,
    'Wrench': <Wrench className={size} />,
    'Package': <Package className={size} />,
    'ShieldCheck': <ShieldCheck className={size} />,
    'Lock': <Lock className={size} />,
    'AlertTriangle': <AlertTriangle className={size} />,

    // Kemahasiswaan
    'Heart': <Heart className={size} />,
    'UserCheck': <UserCheck className={size} />,
    'Award': <Award className={size} />,
    'Medal': <Medal className={size} />,
    'PartyPopper': <PartyPopper className={size} />,
    'BadgeCheck': <BadgeCheck className={size} />,
    'Star': <Star className={size} />,

    // Alumni
    'Briefcase': <Briefcase className={size} />,
    'TrendingUp': <TrendingUp className={size} />,
    'Crown': <Crown className={size} />,
    'Gem': <Gem className={size} />,

    // Humas
    'Megaphone': <Megaphone className={size} />,
    'Camera': <Camera className={size} />,
    'Radio': <Radio className={size} />,
    'Newspaper': <Newspaper className={size} />,
    'Share2': <Share2 className={size} />,
    'Video': <Video className={size} />,
    'Image': <Image className={size} />,

    // Komunikasi
    'Mail': <Mail className={size} />,
    'Phone': <Phone className={size} />,
    'MessageSquare': <MessageSquare className={size} />,
    'Bell': <Bell className={size} />,
    'Send': <Send className={size} />,

    // Umum
    'Tag': <Tag className={size} />,
    'Settings': <Settings className={size} />,
    'Folder': <Folder className={size} />,
    'Clock': <Clock className={size} />,
    'MapPin': <MapPin className={size} />,
    'Info': <Info className={size} />,
    'HelpCircle': <HelpCircle className={size} />,
    'Zap': <Zap className={size} />,
    'Activity': <Activity className={size} />,
    'Target': <Target className={size} />,
  };
  return iconMap[iconName || ''] || <Tag className={size} />;
};

const MasterData: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<TabId>('kategori');
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState<TabId>('kategori');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');

  // State untuk icon picker
  const [iconSearch, setIconSearch] = useState('');
  const [selectedIconCategory, setSelectedIconCategory] = useState<string>('all');

  // Data States
  const [kategori, setKategori] = useState<KategoriMasalah[]>([]);
  const [standar, setStandar] = useState<StandarSPMI[]>([]);
  const [indikator, setIndikator] = useState<IndikatorSPMI[]>([]);
  const [periode, setPeriode] = useState<Periode[]>([]);
  const [editItem, setEditItem] = useState<any>(null);

  // Form states
  const [kategoriForm, setKategoriForm] = useState({
    nama: '', deskripsi: '', color: '#0f33ab', icon: ''
  });
  const [standarForm, setStandarForm] = useState({
    kode: '', nama: '', deskripsi: ''
  });
  const [indikatorForm, setIndikatorForm] = useState({
    standar_spmi_id: '', kode: '', nama: '', deskripsi: '', target_value: ''
  });
  const [periodeForm, setPeriodeForm] = useState({
    nama: '', tahun_ajaran: '', semester: '', tanggal_mulai: '', tanggal_selesai: ''
  });

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get('tab') as TabId | null;
    if (tabParam && TAB_CONFIG.some(t => t.id === tabParam)) {
      setActiveTab(tabParam);
    }
  }, [location.search]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [katRes, stdRes, indRes, perRes] = await Promise.all([
        adminService.kategori.getAll(),
        adminService.standar.getAll(),
        adminService.indikator.getAll(),
        adminService.periode.getAll(),
      ]);

      setKategori(Array.isArray(katRes) ? katRes : (katRes as any).data || []);
      setStandar(Array.isArray(stdRes) ? stdRes : (stdRes as any).data || []);
      setIndikator(Array.isArray(indRes) ? indRes : (indRes as any).data || []);
      setPeriode(Array.isArray(perRes) ? perRes : (perRes as any).data || []);
    } catch (e) {
      console.error(e);
      toast.error('Gagal memuat master data');
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (tab: TabId) => {
    setActiveTab(tab);
    setSearch('');
    navigate(`/admin/master?tab=${tab}`, { replace: true });
  };

  const openCreate = (type: TabId) => {
    setEditItem(null);
    setModalType(type);
    setKategoriForm({ nama: '', deskripsi: '', color: '#0f33ab', icon: '' });
    setStandarForm({ kode: '', nama: '', deskripsi: '' });
    setIndikatorForm({ standar_spmi_id: '', kode: '', nama: '', deskripsi: '', target_value: '' });
    setPeriodeForm({ nama: '', tahun_ajaran: '', semester: '', tanggal_mulai: '', tanggal_selesai: '' });
    setIconSearch('');
    setSelectedIconCategory('all');
    setShowModal(true);
  };

  const openEdit = (type: TabId, item: any) => {
    setEditItem(item);
    setModalType(type);
    if (type === 'kategori') {
      setKategoriForm({
        nama: item.nama,
        deskripsi: item.deskripsi || '',
        color: item.color,
        icon: item.icon || ''
      });
    }
    if (type === 'standar') {
      setStandarForm({
        kode: item.kode,
        nama: item.nama,
        deskripsi: item.deskripsi || ''
      });
    }
    if (type === 'indikator') {
      setIndikatorForm({
        standar_spmi_id: item.standar_spmi_id.toString(),
        kode: item.kode,
        nama: item.nama,
        deskripsi: item.deskripsi || '',
        target_value: item.target_value || '',
      });
    }
    if (type === 'periode') {
      setPeriodeForm({
        nama: item.nama,
        tahun_ajaran: item.tahun_ajaran,
        semester: item.semester,
        // API mengembalikan ISO datetime, input type="date" butuh YYYY-MM-DD
        tanggal_mulai: (item.tanggal_mulai || '').slice(0, 10),
        tanggal_selesai: (item.tanggal_selesai || '').slice(0, 10),
      });
    }
    setIconSearch('');
    setSelectedIconCategory('all');
    setShowModal(true);
  };

  const validatePeriodeForm = (): string | null => {
    const { nama, tahun_ajaran, semester, tanggal_mulai, tanggal_selesai } = periodeForm;
    if (!nama.trim()) return 'Nama periode wajib diisi';
    if (!tahun_ajaran.trim()) return 'Tahun ajaran wajib diisi';
    if (!semester) return 'Semester wajib dipilih';
    if (!tanggal_mulai) return 'Tanggal mulai wajib diisi';
    if (!tanggal_selesai) return 'Tanggal selesai wajib diisi';
    if (tanggal_selesai <= tanggal_mulai) return 'Tanggal selesai harus setelah tanggal mulai';
    return null;
  };

  const handleSave = async () => {
    if (modalType === 'periode') {
      const periodeError = validatePeriodeForm();
      if (periodeError) {
        toast.error(periodeError);
        return;
      }
    }

    setSaving(true);
    try {
      if (modalType === 'kategori') {
        if (editItem) await adminService.kategori.update(editItem.id, kategoriForm);
        else await adminService.kategori.create(kategoriForm);
      } else if (modalType === 'standar') {
        if (editItem) await adminService.standar.update(editItem.id, standarForm);
        else await adminService.standar.create(standarForm);
      } else if (modalType === 'indikator') {
        const payload = {
          ...indikatorForm,
          standar_spmi_id: Number(indikatorForm.standar_spmi_id),
        };
        if (editItem) await adminService.indikator.update(editItem.id, payload);
        else await adminService.indikator.create(payload);
      } else if (modalType === 'periode') {
        if (editItem) await adminService.periode.update(editItem.id, periodeForm);
        else await adminService.periode.create(periodeForm);
      }

      toast.success('Data berhasil disimpan');
      setShowModal(false);
      fetchData();
    } catch (e) {
      console.error(e);
      toast.error(getErrorMessage(e, 'Gagal menyimpan data'));
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (type: TabId, id: number) => {
    let confirmMsg = 'Yakin ingin menghapus data ini?';

    if (type === 'kategori') {
      confirmMsg = 'Yakin ingin menghapus kategori ini?\n\n' +
        '⚠️ Jika ada laporan yang menggunakan kategori ini, penghapusan mungkin akan gagal.\n' +
        '⚠️ Role Scopes yang terkait juga akan terpengaruh.';
    }

    if (type === 'standar') {
      const relatedIndikator = indikator.filter(i => i.standar_spmi_id === id);
      if (relatedIndikator.length > 0) {
        toast.error(`Standar ini memiliki ${relatedIndikator.length} indikator. Hapus indikator terlebih dahulu.`);
        return;
      }
    }

    if (type === 'periode') {
      const periodeItem = periode.find(p => p.id === id);
      if (periodeItem?.is_active) {
        toast.error('Tidak bisa menghapus periode yang sedang aktif');
        return;
      }
    }

    if (!window.confirm(confirmMsg)) return;

    try {
      if (type === 'kategori') await adminService.kategori.delete(id);
      if (type === 'standar') await adminService.standar.delete(id);
      if (type === 'indikator') await adminService.indikator.delete(id);
      if (type === 'periode') await adminService.periode.delete(id);

      toast.success('Data berhasil dihapus');
      fetchData();
    } catch (e: any) {
      const msg = e.response?.data?.message || 'Gagal menghapus data';
      if (msg.includes('foreign key') || msg.includes('constraint')) {
        toast.error('Data tidak bisa dihapus karena masih digunakan di tempat lain');
      } else {
        toast.error(msg);
      }
    }
  };

  const handleSetActivePeriode = async (id: number) => {
    try {
      await adminService.periode.setActive(id);
      toast.success('Periode aktif diperbarui');
      fetchData();
    } catch (e) {
      toast.error('Gagal mengubah periode aktif');
    }
  };

  const getModalTitle = () => {
    const action = editItem ? 'Edit' : 'Tambah';
    const config = TAB_CONFIG.find(t => t.id === modalType);
    return `${action} ${config?.label || ''}`;
  };

  const currentTab = TAB_CONFIG.find(t => t.id === activeTab)!;

  const getDataCount = (tab: TabId): number => {
    switch (tab) {
      case 'kategori': return kategori.length;
      case 'standar': return standar.length;
      case 'indikator': return indikator.length;
      case 'periode': return periode.length;
      default: return 0;
    }
  };

  // Filter icons based on search and category
  const filteredIcons = ICON_OPTIONS.filter(icon => {
    const matchSearch = !iconSearch ||
      icon.label.toLowerCase().includes(iconSearch.toLowerCase()) ||
      icon.value.toLowerCase().includes(iconSearch.toLowerCase());
    const matchCategory = selectedIconCategory === 'all' || icon.category === selectedIconCategory;
    return matchSearch && matchCategory;
  });

  if (loading) {
    return <Loading variant="page" message="Memuat master data..." />;
  }

  return (
    <div className="space-y-6 animate-in">
      <Breadcrumb items={[
        { label: 'Admin', href: '/admin' },
        { label: 'Master Data' },
      ]} />

      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-black text-teal-dark tracking-tight flex items-center gap-2">
            <Sparkles className="w-6 h-6 text-purple-500" />
            Master Data
          </h1>
          <p className="text-sm text-neutral-text-secondary mt-1">
            Kelola data referensi sistem
          </p>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={fetchData}
          icon={loading ? <LogoLoadingMark size="xs" /> : <RefreshCw className="w-4 h-4" />}
        >
          Refresh
        </Button>
      </div>

      {/* Modern Tab Navigation */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {TAB_CONFIG.map((tab) => {
          const isActive = activeTab === tab.id;
          const count = getDataCount(tab.id);

          return (
            <button
              key={tab.id}
              onClick={() => handleTabChange(tab.id)}
              className={`
                relative p-4 rounded-2xl border-2 text-left transition-all group
                ${isActive
                  ? 'border-teal-main bg-gradient-to-br from-teal-50 to-teal-100/50 shadow-lg'
                  : 'border-neutral-border bg-white hover:border-teal-light hover:shadow-md'
                }
              `}
            >
              {isActive && (
                <div className="absolute top-2 right-2 w-2 h-2 bg-teal-main rounded-full animate-pulse" />
              )}

              <div className="flex items-start gap-3">
                <div className={`
                  w-10 h-10 rounded-xl flex items-center justify-center text-white shadow-md
                  ${isActive ? tab.bgColor : 'bg-gray-400'}
                `}>
                  {tab.icon}
                </div>
                <div className="flex-1 min-w-0">
                  <p className={`text-sm font-bold truncate ${isActive ? 'text-teal-dark' : 'text-neutral-text-primary'}`}>
                    {tab.shortLabel}
                  </p>
                  <p className="text-[10px] text-neutral-text-secondary mt-0.5 hidden sm:block">
                    {tab.description}
                  </p>
                </div>
              </div>

              <div className={`
                absolute bottom-2 right-2 px-2 py-0.5 rounded-full text-[10px] font-bold
                ${isActive
                  ? 'bg-teal-main text-white'
                  : 'bg-neutral-bg text-neutral-text-secondary'
                }
              `}>
                {count}
              </div>
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      <Card>
        {/* Tab Header */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
          <div className="flex items-center gap-3">
            <div className={`w-12 h-12 ${currentTab.bgColor} rounded-xl flex items-center justify-center text-white shadow-lg`}>
              {currentTab.icon}
            </div>
            <div>
              <h2 className="text-lg font-bold text-teal-dark">{currentTab.label}</h2>
              <p className="text-xs text-neutral-text-secondary">{currentTab.description}</p>
            </div>
          </div>

          <div className="flex items-center gap-3 w-full sm:w-auto">
            {/* Search */}
            <div className="relative flex-1 sm:flex-initial sm:w-64">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-text-secondary" />
              <input
                type="text"
                placeholder="Cari..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full pl-10 pr-4 py-2 rounded-xl border border-neutral-border text-sm focus:outline-none focus:ring-2 focus:ring-teal-main/20 focus:border-teal-main"
              />
            </div>

            {/* View Toggle */}
            <div className="flex items-center gap-1 p-1 bg-neutral-bg rounded-xl">
              <button
                onClick={() => setViewMode('grid')}
                className={`p-2 rounded-lg transition-all ${viewMode === 'grid' ? 'bg-white shadow-sm text-teal-main' : 'text-neutral-text-secondary'
                  }`}
              >
                <LayoutGrid className="w-4 h-4" />
              </button>
              <button
                onClick={() => setViewMode('list')}
                className={`p-2 rounded-lg transition-all ${viewMode === 'list' ? 'bg-white shadow-sm text-teal-main' : 'text-neutral-text-secondary'
                  }`}
              >
                <List className="w-4 h-4" />
              </button>
            </div>

            {/* Add Button */}
            <Button
              variant="primary"
              size="sm"
              onClick={() => openCreate(activeTab)}
              icon={<Plus className="w-4 h-4" />}
            >
              Tambah
            </Button>
          </div>
        </div>

        {/* KATEGORI TAB */}
        {activeTab === 'kategori' && (
          viewMode === 'grid' ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {kategori
                .filter(k => !search || k.nama.toLowerCase().includes(search.toLowerCase()))
                .map((kat) => (
                  <div
                    key={kat.id}
                    className="relative overflow-hidden rounded-2xl border border-neutral-border hover:border-teal-main/30 hover:shadow-lg transition-all group"
                  >
                    {/* Color Bar */}
                    <div className="h-2" style={{ backgroundColor: kat.color }} />

                    <div className="p-4">
                      <div className="flex items-start justify-between">
                        <div className="flex items-center gap-3">
                          <div
                            className="w-12 h-12 rounded-xl flex items-center justify-center"
                            style={{ backgroundColor: kat.color + '20' }}
                          >
                            <div style={{ color: kat.color }}>
                              {getIconComponent(kat.icon)}
                            </div>
                          </div>
                          <div>
                            <h3 className="text-sm font-bold text-neutral-text-primary">{kat.nama}</h3>
                            <p className="text-xs text-neutral-text-secondary mt-0.5 line-clamp-2">
                              {kat.deskripsi || 'Tidak ada deskripsi'}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="flex items-center justify-between mt-4 pt-3 border-t border-neutral-border/50">
                        <div className="flex items-center gap-2">
                          <div className="w-4 h-4 rounded border" style={{ backgroundColor: kat.color }} />
                          <span className="text-[10px] font-mono text-neutral-text-secondary">{kat.color}</span>
                        </div>
                        <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                          <button
                            onClick={() => openEdit('kategori', kat)}
                            className="p-2 rounded-lg hover:bg-blue-50 text-neutral-text-secondary hover:text-blue-600 transition-colors"
                          >
                            <Edit className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => handleDelete('kategori', kat.id)}
                            className="p-2 rounded-lg hover:bg-red-50 text-neutral-text-secondary hover:text-red-600 transition-colors"
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

              {kategori.filter(k => !search || k.nama.toLowerCase().includes(search.toLowerCase())).length === 0 && (
                <div className="col-span-full text-center py-12">
                  <Tag className="w-12 h-12 mx-auto mb-3 text-neutral-text-secondary opacity-30" />
                  <p className="text-sm text-neutral-text-secondary">Tidak ada kategori ditemukan</p>
                </div>
              )}
            </div>
          ) : (
            <div className="space-y-2">
              {kategori
                .filter(k => !search || k.nama.toLowerCase().includes(search.toLowerCase()))
                .map((kat) => (
                  <div
                    key={kat.id}
                    className="flex items-center gap-4 p-3 rounded-xl border border-neutral-border hover:border-teal-main/30 hover:shadow-sm transition-all group"
                  >
                    <div
                      className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0"
                      style={{ backgroundColor: kat.color + '20' }}
                    >
                      <div style={{ color: kat.color }}>{getIconComponent(kat.icon)}</div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold text-neutral-text-primary">{kat.nama}</p>
                      <p className="text-xs text-neutral-text-secondary truncate">{kat.deskripsi}</p>
                    </div>
                    <div className="w-4 h-4 rounded border shrink-0" style={{ backgroundColor: kat.color }} />
                    <div className="flex items-center gap-1 shrink-0">
                      <button onClick={() => openEdit('kategori', kat)} className="p-2 rounded-lg hover:bg-neutral-bg">
                        <Edit className="w-4 h-4 text-neutral-text-secondary" />
                      </button>
                      <button onClick={() => handleDelete('kategori', kat.id)} className="p-2 rounded-lg hover:bg-red-50">
                        <Trash2 className="w-4 h-4 text-danger" />
                      </button>
                    </div>
                  </div>
                ))}
            </div>
          )
        )}

        {/* STANDAR TAB */}
        {activeTab === 'standar' && (
          <div className="space-y-3">
            {standar
              .filter(s => !search || s.nama.toLowerCase().includes(search.toLowerCase()) || s.kode.toLowerCase().includes(search.toLowerCase()))
              .map((std) => (
                <div
                  key={std.id}
                  className="flex items-center gap-4 p-4 rounded-2xl bg-gradient-to-r from-blue-50/50 to-white border border-blue-200/50 hover:border-blue-300 hover:shadow-md transition-all group"
                >
                  <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shrink-0 shadow-lg">
                    <span className="text-lg font-black text-white">{std.kode.split('-')[1] || std.kode.substring(0, 2)}</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-xs font-mono text-blue-600 bg-blue-100 px-2 py-0.5 rounded">{std.kode}</span>
                    </div>
                    <h3 className="text-sm font-bold text-neutral-text-primary">{std.nama}</h3>
                    <p className="text-xs text-neutral-text-secondary mt-0.5 line-clamp-1">{std.deskripsi}</p>
                  </div>
                  <div className="text-center shrink-0">
                    <p className="text-lg font-bold text-blue-600">
                      {indikator.filter(i => i.standar_spmi_id === std.id).length}
                    </p>
                    <p className="text-[10px] text-neutral-text-secondary">Indikator</p>
                  </div>
                  <div className="flex items-center gap-1 shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
                    <button onClick={() => openEdit('standar', std)} className="p-2 rounded-lg hover:bg-blue-100">
                      <Edit className="w-4 h-4 text-blue-600" />
                    </button>
                    <button onClick={() => handleDelete('standar', std.id)} className="p-2 rounded-lg hover:bg-red-50">
                      <Trash2 className="w-4 h-4 text-danger" />
                    </button>
                  </div>
                </div>
              ))}

            {standar.filter(s => !search || s.nama.toLowerCase().includes(search.toLowerCase())).length === 0 && (
              <div className="text-center py-12">
                <BookOpen className="w-12 h-12 mx-auto mb-3 text-neutral-text-secondary opacity-30" />
                <p className="text-sm text-neutral-text-secondary">Belum ada standar SPMI</p>
              </div>
            )}
          </div>
        )}

        {/* INDIKATOR TAB */}
        {activeTab === 'indikator' && (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-neutral-bg">
                  <th className="text-left px-4 py-3 text-xs font-semibold uppercase tracking-widest text-neutral-text-secondary">Kode</th>
                  <th className="text-left px-4 py-3 text-xs font-semibold uppercase tracking-widest text-neutral-text-secondary">Indikator</th>
                  <th className="text-left px-4 py-3 text-xs font-semibold uppercase tracking-widest text-neutral-text-secondary">Standar</th>
                  <th className="text-left px-4 py-3 text-xs font-semibold uppercase tracking-widest text-neutral-text-secondary">Target</th>
                  <th className="text-left px-4 py-3 text-xs font-semibold uppercase tracking-widest text-neutral-text-secondary">Aksi</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-neutral-border">
                {indikator
                  .filter(i => !search || i.nama.toLowerCase().includes(search.toLowerCase()) || i.kode.toLowerCase().includes(search.toLowerCase()))
                  .map((ind) => (
                    <tr key={ind.id} className="hover:bg-neutral-bg/50 group">
                      <td className="px-4 py-3">
                        <span className="text-xs font-mono text-purple-600 bg-purple-100 px-2 py-0.5 rounded">{ind.kode}</span>
                      </td>
                      <td className="px-4 py-3 text-sm font-medium text-neutral-text-primary max-w-xs">
                        {ind.nama}
                      </td>
                      <td className="px-4 py-3">
                        <span className="text-xs text-neutral-text-secondary">
                          {ind.standar?.kode} - {ind.standar?.nama}
                        </span>
                      </td>
                      <td className="px-4 py-3">
                        <span className="text-sm font-semibold text-purple-600">{ind.target_value || '-'}</span>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                          <button onClick={() => openEdit('indikator', ind)} className="p-1.5 rounded-lg hover:bg-neutral-bg">
                            <Edit className="w-4 h-4 text-neutral-text-secondary" />
                          </button>
                          <button onClick={() => handleDelete('indikator', ind.id)} className="p-1.5 rounded-lg hover:bg-danger/10">
                            <Trash2 className="w-4 h-4 text-danger" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>

            {indikator.filter(i => !search || i.nama.toLowerCase().includes(search.toLowerCase())).length === 0 && (
              <div className="text-center py-12">
                <Target className="w-12 h-12 mx-auto mb-3 text-neutral-text-secondary opacity-30" />
                <p className="text-sm text-neutral-text-secondary">Belum ada indikator SPMI</p>
              </div>
            )}
          </div>
        )}

        {/* PERIODE TAB */}
        {activeTab === 'periode' && (
          <div className="space-y-3">
            {periode
              .filter(p => !search || p.nama.toLowerCase().includes(search.toLowerCase()))
              .map((per) => (
                <div
                  key={per.id}
                  className={`
                    flex items-center justify-between p-4 rounded-2xl border-2 transition-all group
                    ${per.is_active
                      ? 'bg-gradient-to-r from-teal-50 to-teal-100/30 border-teal-300 shadow-md'
                      : 'bg-white border-neutral-border hover:border-teal-200'
                    }
                  `}
                >
                  <div className="flex items-center gap-4">
                    <div className={`
                      w-14 h-14 rounded-xl flex items-center justify-center shadow-md
                      ${per.is_active
                        ? 'bg-gradient-to-br from-teal-500 to-teal-600'
                        : 'bg-gray-200'
                      }
                    `}>
                      <Calendar className={`w-6 h-6 ${per.is_active ? 'text-white' : 'text-gray-500'}`} />
                    </div>
                    <div>
                      <div className="flex items-center gap-2 mb-0.5">
                        <h3 className="text-sm font-bold text-neutral-text-primary">{per.nama}</h3>
                        {per.is_active && (
                          <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-teal-main text-white shadow-sm">
                            AKTIF
                          </span>
                        )}
                      </div>
                      <p className="text-xs text-neutral-text-secondary">
                        {new Date(per.tanggal_mulai).toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' })}
                        {' — '}
                        {new Date(per.tanggal_selesai).toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' })}
                      </p>
                      <p className="text-xs text-neutral-text-secondary mt-1">
                        <span className="font-semibold">{per.tahun_ajaran}</span> • {per.semester}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    {!per.is_active && (
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => handleSetActivePeriode(per.id)}
                        icon={<Check className="w-4 h-4" />}
                        className="text-teal-main hover:bg-teal-50"
                      >
                        Aktifkan
                      </Button>
                    )}
                    <button
                      onClick={() => openEdit('periode', per)}
                      className="p-2 rounded-lg hover:bg-neutral-bg opacity-0 group-hover:opacity-100 transition-opacity"
                    >
                      <Edit className="w-4 h-4 text-neutral-text-secondary" />
                    </button>
                    {!per.is_active && (
                      <button
                        onClick={() => handleDelete('periode', per.id)}
                        className="p-2 rounded-lg hover:bg-danger/10 opacity-0 group-hover:opacity-100 transition-opacity"
                      >
                        <Trash2 className="w-4 h-4 text-danger" />
                      </button>
                    )}
                  </div>
                </div>
              ))}

            {periode.filter(p => !search || p.nama.toLowerCase().includes(search.toLowerCase())).length === 0 && (
              <div className="text-center py-12">
                <Calendar className="w-12 h-12 mx-auto mb-3 text-neutral-text-secondary opacity-30" />
                <p className="text-sm text-neutral-text-secondary">Belum ada periode</p>
              </div>
            )}
          </div>
        )}
      </Card>

      {/* Modal */}
      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title={getModalTitle()}
        size="lg"
        footer={
          <>
            <Button variant="outline" onClick={() => setShowModal(false)}>Batal</Button>
            <Button variant="primary" onClick={handleSave} disabled={saving}>{saving ? <LoadingLabel label="Menyimpan..." /> : 'Simpan'}</Button>
          </>
        }
      >
        <div className="space-y-4">
          {/* Kategori Form */}
          {modalType === 'kategori' && (
            <>
              <Input
                label="Nama Kategori"
                value={kategoriForm.nama}
                onChange={(e) => setKategoriForm({ ...kategoriForm, nama: e.target.value })}
                required
              />
              <Textarea
                label="Deskripsi"
                value={kategoriForm.deskripsi}
                onChange={(e) => setKategoriForm({ ...kategoriForm, deskripsi: e.target.value })}
                rows={3}
              />
              <div className="space-y-2">
                <label className="block text-xs font-semibold uppercase tracking-widest text-neutral-text-secondary">
                  Warna <span className="text-danger">*</span>
                </label>
                <div className="flex items-center gap-3">
                  <input
                    type="color"
                    value={kategoriForm.color}
                    onChange={(e) => setKategoriForm({ ...kategoriForm, color: e.target.value })}
                    className="w-14 h-12 rounded-xl border border-neutral-border cursor-pointer"
                  />
                  <Input
                    value={kategoriForm.color}
                    onChange={(e) => setKategoriForm({ ...kategoriForm, color: e.target.value })}
                    placeholder="#0f33ab"
                    className="flex-1"
                  />
                </div>
              </div>

              {/* IMPROVED ICON PICKER */}
              <div className="space-y-3">
                <label className="block text-xs font-semibold uppercase tracking-widest text-neutral-text-secondary">
                  Icon Kategori
                </label>

                {/* Selected Icon Preview */}
                {kategoriForm.icon && (
                  <div className="flex items-center gap-3 p-3 bg-neutral-bg rounded-xl">
                    <div
                      className="w-12 h-12 rounded-xl flex items-center justify-center"
                      style={{ backgroundColor: kategoriForm.color + '20' }}
                    >
                      <div style={{ color: kategoriForm.color }}>
                        {getIconComponent(kategoriForm.icon)}
                      </div>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-neutral-text-primary">
                        {ICON_OPTIONS.find(i => i.value === kategoriForm.icon)?.label || kategoriForm.icon}
                      </p>
                      <p className="text-xs text-neutral-text-secondary">
                        {ICON_OPTIONS.find(i => i.value === kategoriForm.icon)?.category}
                      </p>
                    </div>
                    <button
                      type="button"
                      onClick={() => setKategoriForm({ ...kategoriForm, icon: '' })}
                      className="ml-auto p-2 rounded-lg hover:bg-red-50 text-neutral-text-secondary hover:text-red-500"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                )}

                {/* Search & Filter */}
                <div className="flex gap-2">
                  <div className="relative flex-1">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-text-secondary" />
                    <input
                      type="text"
                      placeholder="Cari icon..."
                      value={iconSearch}
                      onChange={(e) => setIconSearch(e.target.value)}
                      className="w-full pl-10 pr-4 py-2 rounded-xl border border-neutral-border text-sm focus:outline-none focus:ring-2 focus:ring-teal-main/20 focus:border-teal-main"
                    />
                  </div>
                  <select
                    value={selectedIconCategory}
                    onChange={(e) => setSelectedIconCategory(e.target.value)}
                    className="px-3 py-2 rounded-xl border border-neutral-border text-sm focus:outline-none focus:ring-2 focus:ring-teal-main/20 focus:border-teal-main"
                  >
                    <option value="all">Semua Kategori</option>
                    {ICON_CATEGORIES.map(cat => (
                      <option key={cat.id} value={cat.id}>{cat.label}</option>
                    ))}
                  </select>
                </div>

                {/* Icon Grid */}
                <div className="max-h-64 overflow-y-auto border border-neutral-border rounded-xl p-3">
                  {selectedIconCategory === 'all' ? (
                    // Grouped by category
                    ICON_CATEGORIES.map(category => {
                      const categoryIcons = filteredIcons.filter(i => i.category === category.id);
                      if (categoryIcons.length === 0) return null;

                      return (
                        <div key={category.id} className="mb-4 last:mb-0">
                          <p className="text-xs font-semibold text-neutral-text-secondary mb-2 sticky top-0 bg-white py-1">
                            {category.label}
                          </p>
                          <div className="grid grid-cols-6 sm:grid-cols-8 gap-2">
                            {categoryIcons.map((opt) => (
                              <button
                                key={opt.value}
                                type="button"
                                onClick={() => setKategoriForm({ ...kategoriForm, icon: opt.value })}
                                title={opt.label}
                                className={`
                                  p-2.5 rounded-xl border-2 flex items-center justify-center transition-all
                                  ${kategoriForm.icon === opt.value
                                    ? 'border-teal-main bg-teal-50 shadow-sm'
                                    : 'border-transparent hover:border-neutral-border hover:bg-neutral-bg'
                                  }
                                `}
                              >
                                <div style={{ color: kategoriForm.icon === opt.value ? kategoriForm.color : undefined }}>
                                  {opt.icon}
                                </div>
                              </button>
                            ))}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    // Flat list when category is selected
                    <div className="grid grid-cols-6 sm:grid-cols-8 gap-2">
                      {filteredIcons.map((opt) => (
                        <button
                          key={opt.value}
                          type="button"
                          onClick={() => setKategoriForm({ ...kategoriForm, icon: opt.value })}
                          title={opt.label}
                          className={`
                            p-2.5 rounded-xl border-2 flex flex-col items-center gap-1 transition-all
                            ${kategoriForm.icon === opt.value
                              ? 'border-teal-main bg-teal-50 shadow-sm'
                              : 'border-transparent hover:border-neutral-border hover:bg-neutral-bg'
                            }
                          `}
                        >
                          <div style={{ color: kategoriForm.icon === opt.value ? kategoriForm.color : undefined }}>
                            {opt.icon}
                          </div>
                          <span className="text-[8px] text-neutral-text-secondary truncate w-full text-center">
                            {opt.label}
                          </span>
                        </button>
                      ))}
                    </div>
                  )}

                  {filteredIcons.length === 0 && (
                    <div className="text-center py-8">
                      <Search className="w-8 h-8 mx-auto mb-2 text-neutral-text-secondary opacity-30" />
                      <p className="text-xs text-neutral-text-secondary">Tidak ada icon ditemukan</p>
                    </div>
                  )}
                </div>

                <p className="text-xs text-neutral-text-secondary">
                  Menampilkan {filteredIcons.length} dari {ICON_OPTIONS.length} icon
                </p>
              </div>
            </>
          )}

          {/* Standar Form */}
          {modalType === 'standar' && (
            <>
              <Input
                label="Kode Standar"
                placeholder="STD-01"
                value={standarForm.kode}
                onChange={(e) => setStandarForm({ ...standarForm, kode: e.target.value })}
                required
              />
              <Input
                label="Nama Standar"
                value={standarForm.nama}
                onChange={(e) => setStandarForm({ ...standarForm, nama: e.target.value })}
                required
              />
              <Textarea
                label="Deskripsi"
                value={standarForm.deskripsi}
                onChange={(e) => setStandarForm({ ...standarForm, deskripsi: e.target.value })}
                rows={3}
              />
            </>
          )}

          {/* Indikator Form */}
          {modalType === 'indikator' && (
            <>
              <Select
                label="Standar SPMI"
                options={standar.map(s => ({ value: s.id.toString(), label: `${s.kode} - ${s.nama}` }))}
                placeholder="Pilih standar"
                value={indikatorForm.standar_spmi_id}
                onChange={(val) => setIndikatorForm({ ...indikatorForm, standar_spmi_id: val })}
                required
              />
              <Input
                label="Kode Indikator"
                placeholder="IND-01"
                value={indikatorForm.kode}
                onChange={(e) => setIndikatorForm({ ...indikatorForm, kode: e.target.value })}
                required
              />
              <Input
                label="Nama Indikator"
                value={indikatorForm.nama}
                onChange={(e) => setIndikatorForm({ ...indikatorForm, nama: e.target.value })}
                required
              />
              <Textarea
                label="Deskripsi"
                value={indikatorForm.deskripsi}
                onChange={(e) => setIndikatorForm({ ...indikatorForm, deskripsi: e.target.value })}
                rows={2}
              />
              <Input
                label="Target Value"
                placeholder=">= 80%"
                value={indikatorForm.target_value}
                onChange={(e) => setIndikatorForm({ ...indikatorForm, target_value: e.target.value })}
              />
            </>
          )}

          {/* Periode Form */}
          {modalType === 'periode' && (
            <>
              <Input
                label="Nama Periode"
                placeholder="Semester Ganjil 2025/2026"
                value={periodeForm.nama}
                onChange={(e) => setPeriodeForm({ ...periodeForm, nama: e.target.value })}
                required
              />
              <div className="grid grid-cols-2 gap-4">
                <Input
                  label="Tahun Ajaran"
                  placeholder="2025/2026"
                  value={periodeForm.tahun_ajaran}
                  onChange={(e) => setPeriodeForm({ ...periodeForm, tahun_ajaran: e.target.value })}
                  required
                />
                <Select
                  label="Semester"
                  options={[{ value: 'Ganjil', label: 'Ganjil' }, { value: 'Genap', label: 'Genap' }]}
                  placeholder="Pilih semester"
                  value={periodeForm.semester}
                  onChange={(val) => setPeriodeForm({ ...periodeForm, semester: val })}
                  required
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <Input
                  label="Tanggal Mulai"
                  type="date"
                  value={periodeForm.tanggal_mulai}
                  onChange={(e) => setPeriodeForm({ ...periodeForm, tanggal_mulai: e.target.value })}
                  required
                />
                <Input
                  label="Tanggal Selesai"
                  type="date"
                  value={periodeForm.tanggal_selesai}
                  onChange={(e) => setPeriodeForm({ ...periodeForm, tanggal_selesai: e.target.value })}
                  required
                />
              </div>
            </>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default MasterData;
